import { render, staticRenderFns } from "./ButtonToolbar.vue?vue&type=template&id=23fbddd6&"
import script from "./ButtonToolbar.vue?vue&type=script&lang=js&"
export * from "./ButtonToolbar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports